// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.idioms-page {
  max-width: 900px;
  margin: 0 auto;
  padding: 22px 0 48px;
}

.idioms-header { margin-bottom: 20px; }
.idioms-eyebrow { margin: 0 0 8px; color: #0f766e; font-size: 12px; font-weight: 700; letter-spacing: 0.1em; text-transform: uppercase; }
.idioms-header h1 { margin: 0; color: #183b3b; font-size: clamp(28px, 5vw, 42px); line-height: 1.1; }
.idioms-header p:last-child { margin: 10px 0 0; color: #637878; }

.idioms-tabs {
  display: flex;
  gap: 6px;
  margin-bottom: 18px;
  border-bottom: 1px solid #d7e4e5;
  overflow-x: auto;
}

.idioms-tabs a {
  flex: 1 0 auto;
  border-bottom: 3px solid transparent;
  padding: 11px 16px;
  color: #637878;
  font-weight: 700;
  text-align: center;
  text-decoration: none;
  white-space: nowrap;
}

.idioms-tabs a:hover { background: #f1fbf8; color: #0f766e; }
.idioms-tabs a.active { border-bottom-color: #0f766e; color: #183b3b; }

.idioms-list {
  max-height: calc(100vh - 250px);
  overflow-y: auto;
  padding: 4px 8px 10px;
}

.idioms-status { padding: 30px 0; color: #637878; text-align: center; }
.idioms-status.error { color: #b42318; }

@media (max-width: 600px) {
  .idioms-page { padding-top: 12px; }
  .idioms-tabs a { padding-inline: 12px; }
  .idioms-list { padding-inline: 0; }
}
`, "",{"version":3,"sources":["webpack://./src/pages/idiomsPage.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,cAAc;EACd,oBAAoB;AACtB;;AAEA,iBAAiB,mBAAmB,EAAE;AACtC,kBAAkB,eAAe,EAAE,cAAc,EAAE,eAAe,EAAE,gBAAgB,EAAE,qBAAqB,EAAE,yBAAyB,EAAE;AACxI,oBAAoB,SAAS,EAAE,cAAc,EAAE,iCAAiC,EAAE,gBAAgB,EAAE;AACpG,8BAA8B,gBAAgB,EAAE,cAAc,EAAE;;AAEhE;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,oCAAoC;EACpC,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA,uBAAuB,mBAAmB,EAAE,cAAc,EAAE;AAC5D,wBAAwB,4BAA4B,EAAE,cAAc,EAAE;;AAEtE;EACE,+BAA+B;EAC/B,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA,iBAAiB,eAAe,EAAE,cAAc,EAAE,kBAAkB,EAAE;AACtE,uBAAuB,cAAc,EAAE;;AAEvC;EACE,eAAe,iBAAiB,EAAE;EAClC,iBAAiB,oBAAoB,EAAE;EACvC,eAAe,iBAAiB,EAAE;AACpC","sourcesContent":[".idioms-page {\n  max-width: 900px;\n  margin: 0 auto;\n  padding: 22px 0 48px;\n}\n\n.idioms-header { margin-bottom: 20px; }\n.idioms-eyebrow { margin: 0 0 8px; color: #0f766e; font-size: 12px; font-weight: 700; letter-spacing: 0.1em; text-transform: uppercase; }\n.idioms-header h1 { margin: 0; color: #183b3b; font-size: clamp(28px, 5vw, 42px); line-height: 1.1; }\n.idioms-header p:last-child { margin: 10px 0 0; color: #637878; }\n\n.idioms-tabs {\n  display: flex;\n  gap: 6px;\n  margin-bottom: 18px;\n  border-bottom: 1px solid #d7e4e5;\n  overflow-x: auto;\n}\n\n.idioms-tabs a {\n  flex: 1 0 auto;\n  border-bottom: 3px solid transparent;\n  padding: 11px 16px;\n  color: #637878;\n  font-weight: 700;\n  text-align: center;\n  text-decoration: none;\n  white-space: nowrap;\n}\n\n.idioms-tabs a:hover { background: #f1fbf8; color: #0f766e; }\n.idioms-tabs a.active { border-bottom-color: #0f766e; color: #183b3b; }\n\n.idioms-list {\n  max-height: calc(100vh - 250px);\n  overflow-y: auto;\n  padding: 4px 8px 10px;\n}\n\n.idioms-status { padding: 30px 0; color: #637878; text-align: center; }\n.idioms-status.error { color: #b42318; }\n\n@media (max-width: 600px) {\n  .idioms-page { padding-top: 12px; }\n  .idioms-tabs a { padding-inline: 12px; }\n  .idioms-list { padding-inline: 0; }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
